<template>
    <div>
        <banner title="Apparels & Accessories"></banner>
        <main>
             <section class="pb-5 pt-3">
                 <b-container>
                     <b-row>
                         <b-col md="3" sm="12">
                            <div class="sidebar products-sidebar mb-3">
                                <div class="input-group md-form form-sm form-2 pl-0 mb-3 searchbar">
                                    <input
                                        class="form-control my-0 py-1 red-border rounded-0"
                                        type="text"
                                        placeholder="Search"
                                        aria-label="Search"
                                        v-model="filters.term"
                                    />
                                    <div class="input-group-append">
                                        <span class="input-group-text red lighten-3 rounded-0" id="basic-text1">
                                            <i class="fas fa-search text-grey" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                </div>
                                <b-card no-body >
                                    <b-card-header>
                                        <b-row>
                                            <b-col col md="9">Apparel</b-col>
                                            <b-col col md="1">
                                                <b-button 
                                                    pill light 
                                                    size="sm" 
                                                    variant="outline-secondary" 
                                                    v-b-toggle="'accordion-app'"
                                                >
                                                    <b-icon icon="chevron-down" />
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-card-header>
                                    <b-collapse 
                                        visible accordion="oil-accordion" 
                                        role="tabpanel"
                                        id="accordion-app"
                                    >
                                        <b-form-checkbox-group class="m-3" stacked :options="apparelsOptions" v-model="filters.groups" />
                                    </b-collapse>
                                </b-card>
                                <b-card no-body >
                                    <b-card-header>
                                        <b-row>
                                            <b-col col md="9">Accessories</b-col>
                                            <b-col col md="1">
                                                <b-button 
                                                    pill light 
                                                    size="sm" 
                                                    variant="outline-secondary" 
                                                    v-b-toggle="'accordion-acc'"
                                                >
                                                    <b-icon icon="chevron-down" />
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-card-header>
                                    <b-collapse 
                                        visible accordion="oil-accordion" 
                                        role="tabpanel"
                                        id="accordion-acc"
                                    >
                                        <b-form-checkbox-group class="m-3" stacked :options="accessoriesOptions" v-model="filters.groups" />
                                    </b-collapse>
                                </b-card>
                                <b-button block variant="danger" @click="clearFilters">Clear All</b-button>
                            </div>
                         </b-col>

                         <b-col md="9" sm="12">
                            <b-row>
                                <b-col col cols="12" md="8">
                                    
                                </b-col>
                                <b-col col cols="12" md="4">
                                    <sortBy v-model="filters.replica"></sortBy>
                                </b-col>
                            </b-row>

                            <productList class="mt-4" :loading="searching" :records="hits"> </productList>
                            
                            <b-row>
                                <b-col>
                                    <b-pagination :total-rows="pagination.totalRows" :items="pagination.items" :per-page="filters.hitsPerPage" v-model="filters.page" />
                                </b-col>
                            </b-row>
                         </b-col>
                     </b-row>
                 </b-container>
             </section>
        </main>
    </div>
</template>

<script>
import {api} from '@/config.js'
import banner from '@/components/ProductBanner'
import productList from './Lists'
import sortBy from './SortByField'
import search from '@/libraries/Search'

export default {
    components: {
        banner,
        productList,
        sortBy
    },
    data(){
        let filters = search.setDefaultFilter(this.getDefaultFilters())

        return {
            searching: false,
            searchText: null,
            apparelDepartmentId: 6,
            accessoriesDepartmentId: 5,
            accessoriesOptions: [],
            apparelsOptions: [],
            // brandOptions: [],
            itemGroups: [],
            hits: [],
            pagination: {
				totalRows: null,
				items: []
			},
            filters
        }
    },
    computed: {
		requestFilters() {
            return search.getURLString(this.filters)
		}
    },
    created() {
        this.$router.push('/');
    },
    watch: {
		filters: {
			handler(value) {
				search.setURLParameters(value)
				this.doSearch()
			},
			deep: true
		}
	},
    mounted() {
        let self = this
        this.getGroupings()
        this.doSearch()

        window.onpopstate = function() { self.doSearch() }
    },
    methods: {
        getDefaultFilters() {
			return {
				page: 1,
				hitsPerPage: 20,
				replica: 'products_timestamp_desc',
				departments: ['Apparels','Accessories'],
				groups: null,
				term: null,
			}
		},
        doSearch() {
			let self = this
			let filters = this.requestFilters
			this.searching = true

			fetch(`${api}/products/search?${filters}`, {
				headers: {
					"Content-Type": "application/json",
				},
			}).then(async response => {
				let responseBody = await response.json()
				let _tempPageItems = []
				self.hits = responseBody.hits
				self.searching = false
				self.pagination.totalRows = responseBody.nbHits
				for (let index = 0; index < responseBody.nbPages; index++) {
					_tempPageItems.push(index)
				}
				self.pagination.items = _tempPageItems
			})
		},
        getGroupings() {
            let self = this

            fetch(`${api}/item-groups/reverse?department=${this.apparelDepartmentId}`, {
				headers: {
					"Content-Type": "application/json",
                }
            }).then(async request => {
                let responseBody = await request.json()
                self.apparelsOptions = responseBody.data[0].itemGroups.map(rec => rec.name)
            })

            fetch(`${api}/item-groups/reverse?department=${this.accessoriesDepartmentId}`, {
				headers: {
					"Content-Type": "application/json",
                }
            }).then(async request => {
                let responseBody = await request.json()
                self.accessoriesOptions = responseBody.data[0].itemGroups.map(rec => rec.name)
            })
        },
        clearFilters() {
            this.filters = this.getDefaultFilters()
        }
    }
}
</script>